export default __webpack_public_path__ + "static/media/Champagne and silver Christmas wreath.5d812628.jpg";